import { ReactComponent as Icon } from "../assets/icons/chats/SendArrow.svg";
import genIcons from "./genIcons";

const SendArrow = { Outline: genIcons(Icon, { htmlColor: "transparent", viewBox: "0 0 46 46", fontSize: "large" }) };

export default SendArrow;
